<template>
  <div class="mediaCenter">
    <div class="mtzh_div">
      <el-menu
        :default-active="routePath"
        class="el-menu-vertical-demo mtzh_ul"
        active-text-color="#143372"
        :router="true"
      >
        <el-menu-item>
          <span slot="title">媒体中心</span>
        </el-menu-item>
        <el-menu-item index="/mediaCenter/videoInfo">
          <span slot="title">精彩视频</span>
        </el-menu-item>
        <el-menu-item index="/mediaCenter/pictureInfo">
          <span slot="title">精彩图集</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right_content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "mediaCenter", //媒体中心
  components: {
  },
  data() {
    return {
      tabName: "mqfc",
      routePath: "",
    };
  },
  computed: {
    
  },
  watch: {
   
    $route(to, form) {
	  if (to.path === "/mediaCenter/videoDetails") {
	    this.routePath = "/mediaCenter/videoInfo"
	  } else if (to.path === "/mediaCenter/atlasDetails") {
	    this.routePath = "/mediaCenter/pictureInfo"
	  }else {
	    this.routePath = to.path;
	  }
    },
  },
  activated() {
	  //详细页，左侧选中菜单
    let path = this.$route.path;
    this.routePath = path;
    if (path === "/mediaCenter/videoDetails") {
      this.routePath = "/mediaCenter/videoInfo";
    }
    if (path === "/mediaCenter/atlasDetails") {
      this.routePath = "/mediaCenter/pictureInfo";
    }
  },
  created() {},
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>
.mediaCenter {
  .mtzh_div {
    width: 238px;
    /* height: 256px; */
	height: 190px;
    border-right: 1px solid #4bbc81;
    border-bottom: 1px solid #4bbc81;
    border-left: 1px solid #02b3ea;
    float: left;
    .mtzh_ul {
      font-weight: bold;
      li {
        color: #999999;
        width: 238px;
        height: 64px;
        line-height: 64px;
        text-indent: 11px;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          background-color: #ffffff;
        }
      }
      .is-active {
        background-color: #ffffff;
      }
      li:first-child {
        font-size: 24px;
        font-weight: normal;
        color: #fff;
        cursor: default;
        background-image: linear-gradient(to right, #02b3ea, #4bbc81);
      }
      li:nth-child(3) {
        height: 62px;
        border-top: 1px dashed #f2f2f2;
      }
    }
  }
  .right_content {
    width: 936px;
    min-height: 600px;
    float: right;
  }
  .liActive {
    color: #143372;
  }
}
</style>